import { onCleanup, onMount, Show } from 'solid-js';

export default function Modal(props) {
  let backdropRef;

  // closeOnBackdrop / closeOnEscape (default true) — set false to keep a
  // content-heavy modal (e.g. the form/import editors with a stored-proc field)
  // from being dismissed by an accidental outside-click or Escape, which would
  // discard unsaved work. The × header button and any Cancel button still close.
  const onKeydown = (e) => {
    if (e.key === 'Escape' && props.closeOnEscape !== false) props.onClose?.();
  };

  onMount(() => document.addEventListener('keydown', onKeydown));
  onCleanup(() => document.removeEventListener('keydown', onKeydown));

  return (
    <Show when={props.open}>
      <div
        ref={backdropRef}
        class="modal-backdrop"
        onMouseDown={(e) => { if (e.target === backdropRef && props.closeOnBackdrop !== false) props.onClose?.(); }}
      >
        <div class={`modal-card${props.wide ? ' modal-card-wide' : ''}${props.cardClass ? ' ' + props.cardClass : ''}`} style={props.cardStyle} role="dialog" aria-modal="true">
          <div class="modal-header">
            <h2>{props.title}</h2>
            <button class="modal-close" onClick={props.onClose} aria-label="Close">&times;</button>
          </div>
          <div class="modal-body">{props.children}</div>
        </div>
      </div>
    </Show>
  );
}
